<template>
  <RevInputSelect
    id="number-of-orders-per-page"
    v-model="model"
    class="w-full md:w-280"
    :label="i18n(translations.label)"
    :options
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputSelect } from '@ds/components/InputSelect'

import { PAGE_SIZES } from './PageSizeSelect.constants'
import translations from './PageSizeSelect.translations'

const model = defineModel<string>({ default: '' })
const i18n = useI18n()

const options = PAGE_SIZES.map((countOption) => ({
  label: countOption.toString(),
  value: countOption.toString(),
}))
</script>
